export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter((el) => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export function scrollPageTo(to, duration = 500, offset = 0) {
	//t = current time
	//b = start value
	//c = change in value
	//d = duration
	const easeInOutQuad = function(t, b, c, d) {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	};

	return new Promise((resolve, reject) => {
		const element = document.scrollingElement;

		if (typeof to === 'string') {
			to = document.querySelector(to) || reject();
		}

		if (typeof to !== 'number') {
			to = to.getBoundingClientRect().top + element.scrollTop;
		}

		to = to + offset;

		let start = element.scrollTop,
			change = to - start,
			currentTime = 0,
			increment = 20;

		const animateScroll = function() {
			currentTime += increment;
			let val = easeInOutQuad(currentTime, start, change, duration);
			element.scrollTop = val;
			if (currentTime < duration) {
				requestAnimationFrame(animateScroll);
			} else {
				resolve();
			}
		};
		animateScroll();
	});
}